module.exports = __webpack_public_path__ + "static/media/calender.01adfbb0.png";